import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Layout,
  Form,
  Input,
  Tag,
  Row,
  Col,
  Button
} from 'antd'
import Header from '../Header'
import API from '../../api/index'

const Content = Layout.Content

const CategoryDetail = (props) => {
  const id = props.match.params.id
  const [category, setCategory] = React.useState({})
  const [redirect, setRedirect] = React.useState(undefined)
  const [start_date, setStart_date] = React.useState(undefined)
  const [update_date, setUpdate_date] = React.useState(undefined)

  const getMonth = (index) => {
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 
      'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ]
    return months[index]
  }

  const formatDate = (date) => {
    const newDate = new Date(date)
    return (
      '0' + (newDate.getDate())).slice(-2) + ' de ' + getMonth(newDate.getMonth()) + 
      ' del ' + newDate.getFullYear() + ', ' + ('0' + newDate.getHours()).slice(-2) + 
      ':' + ('0' + newDate.getMinutes()).slice(-2
    )
  }

  const categories = async () => {
    const category = await API.category.detail(id)
    setStart_date(formatDate(category.start_date))
    setUpdate_date(formatDate(category.update_date))
    setCategory(category)
  }

  const onBack = () => {
    setRedirect('/category')
  }

  React.useEffect(() => {
    categories()
  }, [])

  let sections = []
  if (category.sections) {
    category.sections.map((section, index) => (
      sections.push(<Tag color='blue' key={index}>{section.name}</Tag>)
    ))
  }
  if (redirect) {
    return (<Redirect to={redirect} />)
  }
  return (
    <Layout className='layout'>
      <Header item='category' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <h3><strong>Detalle de la categoría</strong></h3>
            </Col>
            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
              <Button onClick={() => onBack()}>Regresar</Button>
            </Col>
          </Row>
          <Form
            layout='vertical'
          >
            <Row>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Nombre'
                >
                  <Input
                    disabled
                    value={category.name}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Imagen'
                >
                  <img
                    alt={category.name}
                    src={category.image}
                    style={{ maxWidth: '30%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1} >
                <Form.Item
                  label='Secciones'
                >
                  {sections}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Fecha de creación'
                >
                  <Input
                    disabled
                    value={start_date}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Fecha de actualización'
                >
                  <Input
                    disabled
                    value={update_date}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>
    </Layout>
  )
}

export default CategoryDetail
